<div [innerHtml]="html | gbSafe: 'html'" class="quill-html"></div>
